module.exports = __webpack_public_path__ + "img/product-img-two.eb5c70e8.png";